import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CurrencyFormatter } from '@jms/model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';

@UntilDestroy()
@Directive({
    selector: '[currencyFormatter]',
    standalone: true,
})
export class CurrencyFormatterDirective implements AfterViewInit, OnDestroy {

    constructor(
        private el: ElementRef,
        @Self() private ngControl: NgControl
    ) {


    }

    ngAfterViewInit(): void {
        this.ngControl
            .valueChanges
            .pipe(
                untilDestroyed(this)
            )
            .subscribe((value) => {
                const newValue = this.validateInput(value);
                if (newValue !== value) {
                    this.ngControl.control.setValue(newValue, { emitEvent: false });
                }
            });
    }

    @HostListener('focus')
    onFocus() {
        const value = this.el.nativeElement.value;
        this.el.nativeElement.value = this.unformatValue(value);
    }

    @HostListener('blur')
    onBlur() {
        const value = this.el.nativeElement.value;
        this.el.nativeElement.value = this.formatValue(value);
    }

    ngOnDestroy() { }

    private formatValue(value: string): string {
        const numberValue = parseFloat(value);
        return CurrencyFormatter.formatCurrency(numberValue);
    }

    private unformatValue(value: string): string {
        return value.replace(/,/g, '');
    }

    private validateInput(value: string): string {
        const regex = /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
        return regex.test(value) ? value : '';
    }
}
